<template>
	<div class="anti-flicker" v-cloak>
		<div ref="btnGoogleLogin" />
		<div class="mt-1 mb-3 text-center" ref="divGoogleLogin" v-show="error">
			<span class="error-msg">Could not sign in with Google. Please <a href="/contact" rel="nofollow" target="_blank">contact support</a> if this keeps happening.</span>
		</div>
	</div>
</template>




<script>
	// Docs/Reference:
	// https://developers.google.com/identity/gsi/web/guides/overview
	// https://developers.google.com/identity/gsi/web/reference/js-reference
	// https://developers.google.com/identity/gsi/web/tools/configurator

	// This components depends on:
	// https://accounts.google.com/gsi/client

	export default {
		mixins: [mixinAxios],
		data: () => ({
			error : false
		}),
		props: {
			clientId    : { type: String,  required: true },
			styling     : { type: String,  default: 'styling0' },
			urlRedirect : { type: String,  default: null },
			width       : { type: Number,  default: 300 },
			autoPrompt  : { type: Boolean, default: true }
		},
		mounted() {
			this.setWidth();
			this.initGoogleLoginButton();
			this.renderGoogleLoginButton();
			this.autoPromptGoogleLogin();
		},
		methods: {
			setWidth() {
				var width = common.parseWidthValue(this.width);
				this.divGoogleLogin.style.width = width;
			},
			redirect() {
				var redirectionNotNull = (this.redirectionUrl != null);

				if (redirectionNotNull) {
					window.location.href = this.redirectionUrl;
				} else {
					window.location.reload();
				}
			},
			handleCredentialResponse(credentialResponse) {
				var googleAccessToken = {
					idToken: credentialResponse.credential
				};

				var signInInfo = {
					googleAccessToken: googleAccessToken,
					clientDateTime: common.getClientDateTimeString()
				};

				return this.mixinAxios().post('/api/guest/GoogleLoginAttempt', signInInfo)
					.then((resGoogleLoginAttempt) => {
						if (resGoogleLoginAttempt.data.success) {
							this.redirect();
						} else {
							this.error = true;
						}
					});
			},
			initGoogleLoginButton() {
				window.google.accounts.id.initialize({
					client_id: this.clientId,
					callback: this.handleCredentialResponse,
					cancel_on_tap_outside: true,
					ux_mode: 'popup',
					auto_select: false,
					itp_support: true,
					use_fedcm_for_prompt: true
				});
			},
			renderGoogleLoginButton() {
				window.google.accounts.id.renderButton(
					this.btnGoogleLogin, {
					type: 'standard',
					theme: 'filled_blue',
					size: 'large',
					text: 'signin_with',
					shape: 'rectangular',
					logo_alignment: 'left',
					width: this.width
				});
			},
			autoPromptGoogleLogin() {
				if (this.autoPrompt) {
					google.accounts.id.prompt();
				}
			}
		},
		computed: {
			btnGoogleLogin() {
				return this.$refs['btnGoogleLogin'];
			},
			divGoogleLogin() {
				return this.$refs['divGoogleLogin'];
			},
			redirectionUrl() {
				var urlFromParam = common.getUrlParameterByName('redirect');

				return (urlFromParam != null)
					? urlFromParam
					: (this.urlRedirect != null)
					? this.urlRedirect
					: null;
			}
		},
		watch: {
			width(newVal, oldVal) {
				this.renderGoogleLoginButton();
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}


	/* common */

	.anti-flicker {
		height: 42px;
		border-top: 1px solid transparent;
		border-bottom: 1px solid transparent;
	}

	.error-msg {
		color: red;
	}

	/* common */


	/* styling 0 */

	.styling0 {
		font-family: 'Roboto', sans-serif;
		font-weight: normal;
		font-size: 16px;
		color: #4C4C4C;
		height: 44px;
		background: #FFFFFF;
		padding:0px 12px;
		display:flex;
		align-items:center;
		justify-content:center;
		border:thin solid #C0C0C0;
		border-radius: 4px;
		cursor:pointer;
	}

	.styling0 img {
		height:22px;
		width:22px;
	}

	.styling0 span {
		margin:3px 0px 0px 10px;
	}

	/* styling 0 */

</style>
